var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBasicData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20360 -1816)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20360 1816)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20353.918 1823.428)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2505.539,3430.44a3.264,3.264,0,0,0-.071-.7c-.206-.915-.424-1.827-.646-2.738q-1.113-4.581-2.232-9.16c-.259-1.059-.661-1.374-1.745-1.374q-7.214,0-14.428,0a1.5,1.5,0,0,0-1.746,1.379c-.819,3.364-1.649,6.726-2.459,10.092a13.269,13.269,0,0,0-.463,2.433c-.074,1.558-.031,3.122-.019,4.684a2.173,2.173,0,0,0,2.251,2.206h19.279a2.185,2.185,0,0,0,2.28-2.263Q-2505.53,3432.72-2505.539,3430.44Zm-3.761-2.025c-.58-.011-1.161.01-1.74-.008a.572.572,0,0,0-.606.374c-.366.773-.768,1.529-1.136,2.3a.529.529,0,0,1-.547.338q-4.1-.009-8.205,0a.555.555,0,0,1-.579-.355c-.366-.773-.771-1.528-1.135-2.3a.545.545,0,0,0-.575-.356c-.608.011-1.216,0-1.823,0-.308,0-.368-.1-.291-.4.624-2.457,1.231-4.918,1.844-7.378.027-.107.06-.212.091-.318.279-.967.279-.967,1.3-.967h5.263c1.92,0,3.841.015,5.76-.012l2.346,7.167c.123.5.218,1,.375,1.483C-2508.837,3428.357-2508.98,3428.421-2509.3,3428.415Z",
    transform: "translate(2529.371 -3416.468)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2450.986,3525.765q-2.568,0-5.135,0c-.536,0-.78-.225-.78-.689a.645.645,0,0,1,.617-.7,2.046,2.046,0,0,1,.248-.007h10.1c.33,0,.644.031.8.384a.681.681,0,0,1-.677,1.008c-1.5.008-3.009,0-4.514,0Z",
    transform: "translate(2462.911 -3515.421)",
    fill: "currentColor",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2434.39,3479.278c1.187,0,2.375,0,3.562,0,.533,0,.788.2.823.615.044.52-.254.82-.839.823-1.118.006-2.237,0-3.355,0-1.256,0-2.513,0-3.769,0-.523,0-.835-.235-.864-.634-.038-.532.219-.8.8-.8C-2436.82,3479.273-2435.6,3479.278-2434.39,3479.278Z",
    transform: "translate(2446.346 -3474.067)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBasicData);
export default __webpack_public_path__ + "static/media/icon-basic-data.49a7f2f1.svg";
export { ForwardRef as ReactComponent };